export interface RVSLookUp {
	ID: number;
	NameEn: string;
	NameAr: string;
}

export interface RVSCompanySearch {
	licenseNo?: string;
	companyNameEn?: string;
	companyNameAr?: string;
	orn?: string;
}

export interface RVSCompany {
	ParticipantTypeId: number;
	ParticipantId: number;
	ParticipantNumber: string;
	NameAr: string;
	NameEn: string;
	IssueDate: string;
	ExpiryDate: string;
	Mobile: string;
	Email: string;
	ContactPersonNameAr: string;
	ContactPersonNameEn: string;
	ContactPersonMobile: string;
	ContactPersonEmail: string;
	TotalRowsCount: number;
	ActivitiesList: CompanyActivity[];
}

export interface CompanyActivity {
	Id: number;
	ActivityId: number;
	ActivityNameAr: string;
	ActivityNameEn: string;
}

export interface RVSError {
	Message: ErrorMessage;
}

export interface ErrorMessage {
	Ar: string;
	En: string;
}

export interface MollakManagementCompany {
	company: {
		identity: number;
		nameEn: string;
		nameAr: string;
	};
	licenseNumber: string;
	licenseAuthorityId: string;
	email: string;
	phone: string;
	mobile: string;
	address: string;
}

export interface MollakDefendant {
	company?: RVSCompany;
	mobile?: string;
	email?: string;
}

export interface Complain {
	ComplainId?: number;
	ServiceId: number;
	ComplainCategoryId: number;
	ComplainantTypeId: number;
	DefendantTypeId: number;
	AuthorityName?: string;
	ComplainerNameEn?: string;
	ComplainerNameAr?: string;
	ActivityId?: number;
	AuthorityParticipantId: number;
	ComplainerMobile?: string;
	ProjectName?: string;
	PlotNumber?: string;
	BuildingNumber?: string;
	UnitNumber?: string;
	PropertyType?: string;
	Community?: string;
}

export interface Participant {
	ParticipantTypeId: number;
	ParticipantId: number;
	ParticipantNumber: string;
	NameAr: string;
	NameEn: string;
	Email: string;
	Mobile: string;
	ContactPersonNameAr: string;
	ContactPersonNameEn: string;
	ContactPersonEmail: string;
	ContactPersonMobile: string;
	ParticipantObject: string;
	Isprimary: boolean;
	IsActive: boolean;
}

export interface TransactionService {
	TransactionStatusId: number;
	ServiceId: number;
	TransactionDescription: string;
	ChannelId: number;
}

export interface Notifier {
	NotifierNameAr: string;
	NotifierNameEn: string;
	NotifierEmail: string;
	NotifierMobile: string;
	NotifierTypeId: number;
	IsActive: boolean;
}

export interface Documents {
	DocumentTypeServiceId: number;
	DocumentTypeId: number;
	ServiceId: number;
	DocumentDetails: DocumentDetail[];
}

export interface DocumentDetail {
	DocumentName: string;
	DocumentPath: string;
	DocumentStates: number;
	DocumentTypeId: number;
}

export interface Transaction {
	CloseReasonNameAr?: string;
	CloseReasonNameEn?: string;
	TransactionNumber?: string;
	Complain: Complain;
	Participants: Participant[];
	TransactionService: TransactionService;
	Notifiers: Notifier[];
	Documents: Documents[];
	SsoRoleId: number;
	ServicesStatus: number;
}

export interface TransactionResult {
	NotifierList: Notifier[];
	ParticipantIdList: string[];
	ServiceId: 1;
	ServiceNameAr: string;
	ServiceNameEn: string;
	ServicesStatus: number;
	TransactionDate: Date;
	TransactionId: string;
	TransactionNumber: string;
	TransactionServiceId: number;
	TransactionStatusId: number;
}

export enum ServiceId {
	OnlineComplain = 1,
}

export enum TransactionStatusId {
	Submit = 2,
	Closed = 7,
}

export enum ChannelId {
	DLDWebsite = 3,
}

export enum NotifierTypeId {
	Complainant = 1,
	Defendant = 2,
}

export enum ServicesStatus {
	IssueService = 1,
}

export enum SSORoleId {
	OnlineUser = 982,
}

export interface RVSDocument {
	fileName: string;
	fileSize: number;
	localFile: File;
	localData: string;
	type: string;
	remoteDoc?: RemoteDoc;
}

export interface RemoteDoc {
	DocumentGuid: string;
	DocumentName: string;
	DocumentUrl: string;
}

export enum DocumentState {
	Uploaded = 1,
}

export enum DocumentTypeId {
	Documents = 1,
}

export interface Complaint {
	TransactionId: number;
	TranactionDate: string;
	TransactionNumber: string;
	TransactionServiceId: number;
	RequestKey: string;
	ServiceId: number;
	ServiceCreatedDate: string;
	ServiceModifiedDate: string;
	TransactionStatusId: number;
	ServiceNameAr: string;
	ServiceNameEn: string;
	TransactionStatusNameAr: string;
	TransactionStatusNameEn: string;
	AuthorityNameAr: string;
	AuthorityNameEn: string;
	LicenseNumber: string;
	ParticipantId: number;
	ShowDownloadComplainButton: boolean;
}
